export default {
    cashier: process.env.VUE_APP_SERVER_DOMAIN,
    passport: process.env.VUE_APP_PASSPORT_DOMAIN,
    center: process.env.VUE_APP_CENTER_DOMAIN,
    topLevel: process.env.VUE_APP_COOKIE_DOMAIN,
    cashierMobile: process.env.VUE_APP_CASHIER_MOBILE_DOMAIN
}
